import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from "@ngrx/store";
import { Circulation, CirculationStatus } from "src/app/interfaces";
import * as AppState from "./../../state/app.state";
import * as fromCirc from "./circulation.reducer";

export interface State extends AppState.State {
  circulation: fromCirc.CirculationState;
}

// Selector functions
const selectCirculationState =
  createFeatureSelector<fromCirc.CirculationState>("circulation");

export const selectCirculationEntities = createSelector(
  selectCirculationState,
  fromCirc.selectCirculationEntities
);

const mapCirculationToClass = (circulation: Circulation): Circulation => {
  if (circulation) {
    return new Circulation(circulation.props, circulation.id);
  }
  return null as Circulation;
};

export const selectCirculation = (
  id: string | number
): MemoizedSelector<State, Circulation> =>
  createSelector(selectCirculationEntities, (circulations) =>
    mapCirculationToClass(circulations[id])
  );

export const selectCurrentCirculation = createSelector(
  selectCirculationEntities,
  AppState.selectCirculationId,
  (state, circId) => mapCirculationToClass(state[circId])
);

export const selectAllCirculations = createSelector(
  selectCirculationState,
  fromCirc.selectAllCirculations
);

export const selectCirculationTotal = createSelector(
  selectCirculationState,
  fromCirc.selectCirculationTotal
);

export const selectCirculationProps = createSelector(
  selectAllCirculations,
  (state) => state.map((circulation) => circulation.props)
);

export const selectCirculationLoaded = createSelector(
  selectCirculationState,
  (state) => state.loaded
);

export const selectCirculationIsLoading = createSelector(
  selectCirculationState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (state) => false
);

export const selectCirculationsByStatus = (props: {
  status: CirculationStatus;
}) =>
  createSelector(selectAllCirculations, (circulations) =>
    circulations.filter((circ) => circ.props.status === props.status)
  );

export const selectCirculationError = createSelector(
  selectCirculationState,
  (state) => state.error
);

export const selectSavedCirculationId = createSelector(
  selectCirculationState,
  (state) => state.savedCirculationId
);

export const selectUploadDocumentFailed = createSelector(
  selectCirculationState,
  (state) => state.uploadDocumentFailed
);

export const selectUploadDocumentCompleted = createSelector(
  selectCirculationState,
  (state) => state.uploadDocumentCompleted
);
